import { Container, Row, Col, Accordion } from "react-bootstrap";
import { motion } from "framer-motion";
import "./aboutDoctor.css";
import CustomNavbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

function AboutDoctorVishnu() {
  return (
    <>
    <CustomNavbar />
    <section className="about-doctor py-5">

      <Container>

        {/* TOP HEADING */}
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="section-title">
            ABOUT DR. VISHNU SHIVAJI SHINDE
          </h2>
        </motion.div>

        {/* ROW 1 */}

        <Row className="align-items-center doctor-top">

          {/* IMAGE */}

          <Col lg={4} md={5} className="text-center mb-4">
            <motion.img
              src="/drVishnu.jpeg"
              alt="Dr Vishnu Shinde"
              className="doctor-img"
              initial={{ opacity: 0, x: -80 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            />
          </Col>

          {/* INFO */}

          <Col lg={8} md={7}>

            <motion.div
              initial={{ opacity: 0, x: 80 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >

              <h3 className="doctor-name">Dr. Vishnu Shivaji Shinde</h3>

              <p className="doctor-degree">
                BAMS | Family Physicians 
              </p>

              <ul className="doctor-details">
                <li><strong>Reg No:</strong> I- 97295-A</li>
                <li><strong>Experience:</strong> 5+ Years</li>
                <li><strong>Clinic:</strong> Dr Trupti's Health And Beauty Clinic</li>
                <li><strong>Email:</strong> drtrupticlinic@gmail.com</li>
                <li><strong>Phone:</strong> +91 9511291664</li>
              </ul>

              <p className="doctor-desc">
                Dr. Vishnu Shinde, a dedicated family physician who believes that the best medicine is built on trust, 
                longevity, and care.
              </p>

            </motion.div>

          </Col>

        </Row>

        {/* ACCORDION */}

        <Row className="mt-5">
          <Col>

            <motion.div
              initial={{ opacity: 0, y: 80 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >

              <Accordion defaultActiveKey="0" className="doctor-accordion">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>Education</Accordion.Header>
                  <Accordion.Body>
                    BAMS - Aaryangla Vaidyak  Mahavidyalay Satara.
                    
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>Achievements</Accordion.Header>
                  <Accordion.Body>
                    Best Cosmetologist Award 2025. <br/>
                    Member of Indian Association of Cosmetologist.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>Work Experience</Accordion.Header>
                  <Accordion.Body>
                    Sub District Hospital Satara. <br/>
                    Jijamata Hospital Pimpari Chinchwad. <br/>
                    YCM Hospital Pimpari Chinchwad. <br/>
                    Indrayani Hospital Aalandi.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="4">
                  <Accordion.Header>Area of Interest</Accordion.Header>
                  <Accordion.Body>
                    Acne Treatment <br/>
                    Hair Loss Treatment <br/>
                    Laser Skin Procedures <br/>
                    Anti-Aging Therapy
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>

            </motion.div>

          </Col>
        </Row>

      </Container>

    </section>

    <Footer />
    </>
  );
}

export default AboutDoctorVishnu;